export const MAX_VIEWPORT_WIDTH = 860;
